const ALL_COMBINING_DIACRITICS =
  // eslint-disable-next-line no-misleading-character-class
  /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]+/g;

/**
 * Replaces accented characters with their non-accented counterparts.<br>
 * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
 *
 * @param {string} content - The content to remove accents from
 * @param {boolean} [remove=false] - Whether to remove unicode characters that are not mapped to a
 * non-accented characters. This includes all non-ascii characters.
 * @param {string} [replacement=Empty string] - The replacement to use for invalid characters.
 * @returns {string} String without accents.
 * @example
 * // returns 'My accented string$.'
 * noAccents('My áccentéd string$.');
 */
export default (content, remove = false, replacement = '') => {
  let withoutAccents = String(content)
    .normalize('NFKD')
    .replace(ALL_COMBINING_DIACRITICS, '');
  if (remove) {
    // x00-x7E is the ASCII character range
    withoutAccents = withoutAccents.replace(/[^\u0020-\u007E]/g, replacement);
  }
  return withoutAccents;
};
